import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../slice/userSlice";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ["isLoading", "isAuthenticated", "account", "userData", "adminData"],
};

const persistedReducer = persistReducer(persistConfig, userReducer);

export const store = configureStore({
    reducer: {
        admin: persistedReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Bỏ qua các actions của redux-persist
            },
        }),
});

export const persistor = persistStore(store);